<div class="d-flex align-items-center">
  <div class="service-catalog w-100" id="service-catalog-1">
    <div class="text-center mb-4" id="service-catalog-head">
      <h1>{{ 'CATALOG_IT_SERVICE' | translate }}</h1>
      <div class="service-catalog-desc font-size-16">
        {{ 'SELF_DIAGNOSTIC_INFO' | translate }}
      </div>
    </div>

    <div class="service-catalog-search mb-3">
      <div id="search-service" class="search-service">
        <div id="service-catalog-2" class="flex-grow-1">
          <shared-search-service-full></shared-search-service-full>
        </div>

        <!-- [SDW-830] tmp comment this code -->
        <!--<div>
        <dx-button text="{{'NEXT' | translate}}" *ngIf="this.selectedSearchResult" (onClick)="this.goToSelfDiagnosticStepsFromSearch(this.selectedSearchResult)" class="btn btn-search" icon="mdi mdi-chevron-right"></dx-button>
      </div>-->
      </div>
    </div>

    <dx-accordion
      #dxAccordion
      id="service-catalog-3"
      [dataSource]="this.masterCategories"
      [collapsible]="true"
      [multiple]="true"
      [selectedIndex]="null"
      [animationDuration]="350"
      class="accordion-catalog">
      <div *dxTemplate="let masterCategory of 'title'">
        <div class="dx-accordion-item-title-value">
          @if (masterCategory.iconBody) {
            <img
              [src]="
                this.sanitizer.bypassSecurityTrustResourceUrl('data:' + masterCategory.iconType + ';base64,' + masterCategory.iconBody)
              " />
          }

          {{ this.isUkLanguage ? masterCategory.nameUa : masterCategory.nameRu }}
        </div>
      </div>
      <div *dxTemplate="let masterCategory of 'item'">
        <dx-accordion
          #dxAccordion
          [dataSource]="masterCategory.categories"
          [collapsible]="true"
          [multiple]="true"
          [selectedIndex]="null"
          [animationDuration]="350"
          class="accordion-catalog-level2">
          <div *dxTemplate="let category of 'title'">
            <div class="dx-accordion-item-title-block">
              <div class="dx-accordion-item-title-value category">
                {{
                  this.isUkLanguage
                    ? category.webNameUa
                      ? category.webNameUa
                      : category.nameUa
                    : category.webNameRu
                      ? category.webNameRu
                      : category.nameRu
                }}
                @if (category.iconBody) {
                  <img
                    [src]="this.sanitizer.bypassSecurityTrustResourceUrl('data:' + category.iconType + ';base64,' + category.iconBody)" />
                }
              </div>

              <div class="service-catalog-level2-desc">
                {{ this.isUkLanguage ? category.descriptionUa : category.descriptionRu }}
              </div>
            </div>
          </div>
          <div *dxTemplate="let category of 'item'">
            @for (service of category.services; track service) {
              <div>
                <dx-button class="category-name" [disabled]="false" (onClick)="this.goToSelfDiagnosticStepsFromCatalog(service)">
                  <div innerHTML="{{ this.isUkLanguage ? service.nameUa : (service.nameRu | highlight: searchText) }}"></div>
                </dx-button>
                @if ((this.isUkLanguage && service.descriptionUa) || (!this.isUkLanguage && service.descriptionRu)) {
                  <div class="mdi">
                    <div class="catalog-item-tooltip">
                      {{ this.isUkLanguage ? service.descriptionUa : service.descriptionRu }}
                    </div>
                  </div>
                }
              </div>
            }
          </div>
        </dx-accordion>
      </div>
    </dx-accordion>
  </div>
</div>
